import { useSnackbar } from '@lambdacurry/component-library';

interface Error {
  message: string;
  extensions: {
    code: string;
    response: { statusCode: number; message: string | string[]; error: string };
  };
}
interface ErrorResponse {
  response: {
    errors: Error[];
    data: any;
    status: number;
    headers: { map: { [x: string]: string } };
  };
  request: {
    query: string;
    variables: any;
  };
}

const messagesToIgnore = ['Authorization header not found.', 'Token not valid'];

const filterErrorsFromSnackbar = (error: Error) => {
  if (messagesToIgnore.includes(error.message)) return false;
  return true;
};

export const useHandleQueryError = ({ onTokenInvalid }: { onTokenInvalid: () => void }) => {
  const { addSnackbar } = useSnackbar();

  const handleQueryError = (error: ErrorResponse) => {
    // TODO: we will probably want better logic for what messages actually get displayed to the end user here
    const errors = error?.response?.errors;

    if (!errors) return;

    if (errors.length < 1) return addSnackbar('Unknown error occurred', { variant: 'error' });

    // NOTE: We have moved the redirect logic to our `PrivateLayout` component so we can determine how to handle unauthorized queries at the component level.
    // if (
    //   errors.find(error => error.message === 'Authorization header not found.' || error.message === 'Token not valid')
    // )
    //   return navigate(`/login?redirect=${encodeURIComponent(location.pathname)}`);

    return error.response.errors.forEach(error => {
      let message = error.message;

      // Question: Should we map the input errors to their corresponding field names?
      if (error.extensions?.code === 'BAD_USER_INPUT') {
        message = Array.isArray(error.extensions.response.message)
          ? error.extensions.response.message.join(', ')
          : error.extensions.response.message;
      }

      if (message === 'Token not valid') onTokenInvalid ? onTokenInvalid() : null;
      if (filterErrorsFromSnackbar(error)) addSnackbar(message, { variant: 'error' });
    });
  };

  return { handleQueryError };
};
